import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { Evento } from '../../comum/eventos/evento';
import { ComumService } from '../../comum/comum.service';
import { ComentarioOcorrencia } from '../../comum/modelos/comentario-ocorrencia';
import { CriterioAvaliacaoRotinaCliente } from '../../comum/modelos/criterio-avaliacao-rotina-cliente';
import { Ocorrencia } from '../../comum/modelos/ocorrencia';
import { ProcessoSetor } from '../../comum/modelos/processo-setor';
import { RotinaProcesso } from '../../comum/modelos/rotina-processo';
import { SetorPontoFisico } from '../../comum/modelos/setor-ponto-fisico';
import { StatusOcorrencia } from '../../comum/modelos/status-ocorrencia';
import { ProcessoService } from '../../processo/processo.service';
import { RotinaService } from '../../rotina/rotina.service';
import { SetorService } from '../../setor/setor.service';
import { OcorrenciasService } from '../ocorrencias.service';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { UsuarioService } from '../../usuario/usuario.service';
import { Usuario } from '../../comum/modelos/usuario';
import { CookieService } from 'angular2-cookie/core';
import { AuthService } from '../../auth/auth.service';
import { Data } from '../../comum/data/data';
import { FiltroOcorrencia } from '../../comum/modelos/filtro-ocorrencia';
import { AcompanhamentoAlcada } from '../../comum/modelos/acompanhamento-alcada';
import { EmailOcorrencia } from '../../comum/modelos/email-ocorrencia';
import { ConfirmationService } from 'primeng/primeng';

@Component({
    selector: 'app-detalhe-ocorrencia',
    templateUrl: './detalhe-ocorrencia.component.html',
    styleUrls: ['./detalhe-ocorrencia.component.css']
})
export class DetalheOcorrenciaComponent implements OnInit {

    ocorrencia: Ocorrencia;
    statusOcorrencia: StatusOcorrencia[];
    alcadas: AcompanhamentoAlcada[];
    comentarioOcorrencia: ComentarioOcorrencia;
    setorPontoFisico: SetorPontoFisico;
    processoSetor: ProcessoSetor;
    rotinaProcesso: RotinaProcesso;
    criterioAvaliacaoRotinaCliente: CriterioAvaliacaoRotinaCliente;
    usuario: Usuario;
    usuarios: Usuario[];
    email: EmailOcorrencia;
    origem: String;
    filtroOcorrencia: FiltroOcorrencia;

    statusCode: number;

    public evento: Evento;

    public loading = false;

    constructor (
        private _comumService: ComumService,
        private _ocorrenciasService: OcorrenciasService,
        private _setorService: SetorService,
        private _processoService: ProcessoService,
        private _rotinaService: RotinaService,
        private _usuarioService: UsuarioService,
        private _activatedRoute: ActivatedRoute,
        private router: Router,
        private _cookieService: CookieService,
        public _authService: AuthService,
        private confirmationService: ConfirmationService,
        private data: Data) {
        this.ocorrencia = new Ocorrencia();
        this.comentarioOcorrencia = new ComentarioOcorrencia();
        this.statusOcorrencia = new Array<StatusOcorrencia>();
        this.setorPontoFisico = new SetorPontoFisico();
        this.processoSetor = new ProcessoSetor();
        this.rotinaProcesso = new RotinaProcesso();
        this.criterioAvaliacaoRotinaCliente = new CriterioAvaliacaoRotinaCliente();
        this.usuario = new Usuario();
        this.filtroOcorrencia = new FiltroOcorrencia();
        this.alcadas = new Array<AcompanhamentoAlcada>();
        this.usuarios = new Array<Usuario>();
        this.email = new EmailOcorrencia();
        this.evento = this._comumService.evento;
    }

    ngOnInit() {
        this.loading = true;
        const id = this._activatedRoute.snapshot.params['id'];
        const idCliente = parseInt(this._cookieService.get('idCliente'), 10);
        this.origem = this._activatedRoute.snapshot.params['origem'];
        if (this.origem.toString() === 'GRAFICO') {
            this.filtroOcorrencia = this.data.storage.filtroOcorrencia;
        }
        const self = this;

        forkJoin(this._ocorrenciasService.obterOcorrenciaHttp(id),
            this._ocorrenciasService.obterStatusOcorrenciasHttp(),
            this._usuarioService.obterUsuariosHttp(idCliente))
            .subscribe(([ocorrencia, status, usuarios]) => {
                self.ocorrencia = ocorrencia;
                self._usuarioService.obterUsuarioPorIdHttp(ocorrencia.idUsuario)
                    .subscribe(usuario => {
                        self.usuario = usuario;
                    });
                self.usuarios = usuarios;
                self.ocorrencia.dataAbertura = new Date(ocorrencia.dataAbertura);
                self.statusOcorrencia = status;
                forkJoin(self._setorService.obterSetorPontoFisicoHttp(
                    ocorrencia.idSetorPontoFisico === null ? 0 : ocorrencia.idSetorPontoFisico),
                    self._processoService.obterProcessoSetorHttp(ocorrencia.idProcessoSetor === null ? 0 : ocorrencia.idProcessoSetor),
                    self._rotinaService.obterRotinaProcessoHttp(ocorrencia.idRotinaProcesso === null ? 0 : ocorrencia.idRotinaProcesso),
                    self._rotinaService.obterCriterioAvaliacaoRotinaClienteHttp
                        (ocorrencia.idCriterioAvaliacaoRotinaCliente === null ? 0 : ocorrencia.idCriterioAvaliacaoRotinaCliente))
                    .subscribe(([setorPontoFisico, processoSetor, rotinaProcesso, criterioAvaliacaoRotinaCliente]) => {
                        if (setorPontoFisico !== null && setorPontoFisico !== undefined) {
                            self.setorPontoFisico = setorPontoFisico;
                        }
                        if (processoSetor !== null && processoSetor !== undefined) {
                            self.processoSetor = processoSetor;
                        }
                        if (rotinaProcesso !== null && rotinaProcesso !== undefined) {
                            self.rotinaProcesso = rotinaProcesso;
                        }
                        if (criterioAvaliacaoRotinaCliente !== null && criterioAvaliacaoRotinaCliente !== undefined) {
                            self.criterioAvaliacaoRotinaCliente = criterioAvaliacaoRotinaCliente;
                        }
                    });
                if (self.ocorrencia.tipoOcorrencia.descricaoTipoOcorrencia === 'Autom\u00e1tica') {
                    self._ocorrenciasService.obterControleOcorrenciaAutoHttp(self.ocorrencia.idOcorrencia).subscribe(controle => {
                        if (controle !== null && controle !== undefined) {
                            self._ocorrenciasService.obterAgendamentoOcorrenciaAutoHttp(controle.idConfigOcorrenciaAuto)
                            .subscribe(config => {
                                forkJoin(self._usuarioService.obterUsuarioPorIdHttp(config.idUsuario),
                                    self._usuarioService.obterUsuarioPorIdHttp(config.idUsuarioPrimeiraAlcada),
                                    self._usuarioService.obterUsuarioPorIdHttp(config.idUsuarioSegundaAlcada),
                                    self._usuarioService.obterUsuarioPorIdHttp(config.idUsuarioTerceiraAlcada))
                                    .subscribe(([primeiro, segundo, terceiro, quarto]) => {
                                        const alcada1 = new AcompanhamentoAlcada();
                                        const alcada2 = new AcompanhamentoAlcada();
                                        const alcada3 = new AcompanhamentoAlcada();
                                        const alcada4 = new AcompanhamentoAlcada();

                                        alcada1.numeroAlcada = 1;
                                        alcada1.nomeUsuario = primeiro.nomeUsuario;
                                        alcada1.horasAlcada = 0;
                                        alcada1.horasConfig = 0;
                                        alcada1.dataAlteracao = self.ocorrencia.dataAbertura;

                                        alcada2.numeroAlcada = 2;
                                        alcada2.nomeUsuario = segundo.nomeUsuario;
                                        alcada2.horasAlcada = controle.horasPrimeiraAlcada;
                                        alcada2.horasConfig = config.numeroHorasPrimeiraAlcada;
                                        alcada2.dataAlteracao = controle.dataPrimeiraAlcada;

                                        alcada3.numeroAlcada = 3;
                                        alcada3.nomeUsuario = terceiro.nomeUsuario;
                                        alcada3.horasAlcada = controle.horasSegundaAlcada;
                                        alcada3.horasConfig = config.numeroHorasSegundaAlcada;
                                        alcada3.dataAlteracao = controle.dataSegundaAlcada;


                                        alcada4.numeroAlcada = 4;
                                        alcada4.nomeUsuario = quarto.nomeUsuario;
                                        alcada4.horasAlcada = controle.horasTerceiraAlcada;
                                        alcada4.horasConfig = config.numeroHorasTerceiraAlcada;
                                        alcada4.dataAlteracao = controle.dataTerceiraAlcada;

                                        self.alcadas.push(alcada1);
                                        self.alcadas.push(alcada2);
                                        self.alcadas.push(alcada3);
                                        self.alcadas.push(alcada4);
                                    });
                            });
                        }
                    });
                }
                self.loading = false;
            });
    }

    onSubmit(): void {
        this.loading = true;
        const self = this;

        if (self.ocorrencia.statusOcorrencia.descricaoStatusOcorrencia === 'Cancelada'
            || self.ocorrencia.statusOcorrencia.descricaoStatusOcorrencia === 'Resolvido') {
            self.ocorrencia.dataEncerramento = new Date();
        }

        self.ocorrencia.idUsuario = JSON.parse(self._cookieService.get('usuario')).idUsuario;
        self._ocorrenciasService.atualizarOcorrenciaHttp(self.ocorrencia)
            .subscribe(response => {
                self.loading = false;
                self.statusCode = response.status;
                self._comumService.evento.cadastro = true;
                if (this.origem.toString() === 'BAIXA') {
                    self.router.navigate(['listar-ocorrencias']);
                }
                if (this.origem.toString() === 'VISAO') {
                    self.router.navigate(['visao-geral-ocorrencias']);
                }
                if (this.origem.toString() === 'GRAFICO') {
                    self.router.navigate(['listar-ocorrencias-grafico', this.filtroOcorrencia.origem]);
                }
            }, errorCode => {
                self.statusCode = errorCode;
                self.loading = false;
            });
    }

    adicionarComentario(): void {
        this.comentarioOcorrencia.idOcorrencia = this.ocorrencia.idOcorrencia;
        this.comentarioOcorrencia.usuario = JSON.parse(this._cookieService.get('usuario'));
        this.comentarioOcorrencia.dataComentario = new Date();

        this._ocorrenciasService.inserirComentarioOcorrenciaHttp(this.comentarioOcorrencia)
            .subscribe(response => {
                this.loading = false;
                this.statusCode = response.status;
                this._comumService.evento.cadastro = true;
                this.ocorrencia.comentariosOcorrencia.push(response.body);
                this.comentarioOcorrencia = new ComentarioOcorrencia();
            }, errorCode => {
                this.statusCode = errorCode;
                this.loading = false;
            });
    }

    atualizarProgresso() {
        this._ocorrenciasService.obterStatusOcorrenciaHttp(this.ocorrencia.statusOcorrencia.idStatusOcorrencia)
            .subscribe(statusOcorrencia => {
                this.ocorrencia.statusOcorrencia = statusOcorrencia;
            });
    }

    enviarEmail() {
        this.email.assunto = 'Email Ocorr\u00eancia ' + this.ocorrencia.idOcorrencia;
        if (this.email.assunto === undefined || this.email.destinatario === undefined) {
            this.confirmationService.confirm({
                rejectVisible: false,
                message: 'Informar o conte\u00fado e o destinat\u00e1rio do email',
                accept: () => { },
                reject: () => { }
            });
        } else {
            this._ocorrenciasService.enviarEmailOcorrenciaHttp(this.email)
                .subscribe(response => {
                    this.loading = false;
                    this.statusCode = response.status;
                    this._comumService.evento.cadastro = true;
                    this.email = response.body;
                    this.confirmationService.confirm({
                        rejectVisible: false,
                        message: 'Email enviado',
                        accept: () => { },
                        reject: () => { }
                    });
                }, errorCode => {
                    this.statusCode = errorCode;
                    this.loading = false;
                });
        }
    }
}



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/ocorrencias/detalhe-ocorrencia/detalhe-ocorrencia.component.ts